

export default function FAQ(props) {

		let {data} = props
		let faq = []
		let index = 0

		for(let key in data.list){
				if( data.list.hasOwnProperty(key) ) {

					let current = data.list[key]

			let rowBackgroundColor = index % 2 ? '#F5FCFF' : '#DDECF3'
			index ++

			faq.push (<div className='row col-xs-12' style={{ backgroundColor: rowBackgroundColor, padding: '10px 0px'}}>
								<div className='col-xs-12' style={{padding: '20px 20px 5px 20px'}}>
									<b className='faq-question-text'>{current.q}</b>
								</div>
								<div className='col-xs-12' style={{padding: '5px 20px 10px 20px'}}>
									<span className='faq-answer-text '>{current.a}</span>
								</div>
							</div>
							)
						}
					}

		return(
				<div className='row' >

				<div className='col-xs-12 s1-header'>
					Frequently Asked Questions
				</div>

				{faq}

				</div>
    )


}



// WEBPACK FOOTER //
// ./components/contentTypes/faq/faq.js